import { render, staticRenderFns } from "./AiTask.vue?vue&type=template&id=72cf3640&scoped=true"
import script from "./AiTask.vue?vue&type=script&lang=js"
export * from "./AiTask.vue?vue&type=script&lang=js"
import style0 from "./AiTask.vue?vue&type=style&index=0&id=72cf3640&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf3640",
  null
  
)

export default component.exports